import React from 'react';
import './footer.css';
const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container">
        <h3 className="sitename">Gantasoft</h3>
        <p>
        Crafting Software for a Smarter World.
        </p>
        
        <div className="social-links d-flex justify-content-center ">
          <a href="/#home" aria-label="Twitter" >
            <i className="bi bi-twitter-x text-white"></i>
          </a>
          <a href="/#home" aria-label="Facebook">
            <i className="bi bi-facebook text-white"></i>
          </a>
          <a href="/#home" aria-label="Instagram">
            <i className="bi bi-instagram text-white"></i>
          </a>
          <a href="/#home" aria-label="Skype">
            <i className="bi bi-skype text-white"></i>
          </a>
          <a href="/#home" aria-label="LinkedIn">
            <i className="bi bi-linkedin text-white"></i>
          </a>
        </div>
        <div className="copyright">
          <span>Copyright</span> <strong className="px-1 sitename">Gantasoft</strong>{' '}
          <span>All Rights Reserved</span>
        </div>
        <div className="credits">
          Designed by{' '}
          <a href="/#home" target="_blank" rel="noopener noreferrer" className="text-white">
            Gantasoft
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
